/* BoobyBiome pre-launch site v22.8 - prototype script, hash router replaced by Shopify routes. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- HOOK: type · delete · retype ---------- */
  var wordEl = document.getElementById('typedWord');
  var caret = document.getElementById('caret');
  var words = ['builds immunity.', 'is an ecosystem.', 'nourishes.', 'protects.', 'is unique.'];

  if (!reduced && wordEl && caret) {
    wordEl.textContent = '';
    var wi = 0;

    function setIdle(idle) { caret.classList.toggle('idle', idle); }

    function typeWord(word, done) {
      setIdle(false);
      var i = 0;
      (function step() {
        wordEl.textContent = word.slice(0, ++i);
        if (i < word.length) {
          setTimeout(step, 62 + Math.random() * 74);
        } else { setIdle(true); done(); }
      })();
    }

    function deleteWord(done) {
      setIdle(false);
      (function step() {
        var t = wordEl.textContent;
        wordEl.textContent = t.slice(0, -1);
        if (wordEl.textContent.length) { setTimeout(step, 36); }
        else { done(); }
      })();
    }

    function cycle() {
      var word = words[wi];
      typeWord(word, function () {
        setTimeout(function () {
          deleteWord(function () {
            wi = (wi + 1) % words.length;
            setTimeout(cycle, 340);
          });
        }, 1250);
      });
    }
    setTimeout(cycle, 900); /* let the reveal breathe first */
  }

  /* shared easing (easeInOutCubic). It lived in the old hero block; the oxygen chart's line draw still calls it. */
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* ---------- MEET BYOMI: Will's render scrubbed by scroll; the labels ride on the parts (24 Sep) ---------- */
  (function () {
    var section = document.getElementById('assemblySection');
    var wrap = document.getElementById('asmWrap'), pin = document.getElementById('asmPin');
    var stage = document.getElementById('asmStage'), cv = document.getElementById('asmCanvas');
    var svg = document.getElementById('asmLeaders');
    if (!section || !stage || !cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    /* Anchors, as fractions of the cropped frame (1060x1584), measured from every frame: the right edge of the pod,
       the left edge of the adapter ring, the left edge of the jar. */
    var A = {"pod":[[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0717],[0.4047,0.0719],[0.4047,0.0723],[0.4047,0.0729],[0.4047,0.0738],[0.4046,0.0748],[0.4045,0.0763],[0.4044,0.078],[0.4043,0.0801],[0.4042,0.0824],[0.4041,0.0851],[0.404,0.0883],[0.4038,0.0921],[0.4036,0.0963],[0.4035,0.1011],[0.4032,0.1064],[0.403,0.1125],[0.4028,0.1192],[0.4025,0.127],[0.4022,0.1356],[0.4018,0.1453],[0.4015,0.156],[0.401,0.168],[0.4005,0.1813],[0.4001,0.1956],[0.3997,0.211],[0.4019,0.2272],[0.4042,0.244],[0.4065,0.2588],[0.4088,0.2701],[0.4111,0.2775],[0.4134,0.2831],[0.4156,0.2879],[0.4176,0.2922],[0.4196,0.2959],[0.419,0.2991],[0.4181,0.3019],[0.4166,0.3043],[0.4143,0.3063],[0.4109,0.308],[0.407,0.3094],[0.4026,0.3107],[0.3977,0.3116],[0.3922,0.3125],[0.3866,0.3132],[0.3811,0.3136],[0.3764,0.3138],[0.3725,0.3138],[0.3697,0.3138]],"adapter":[[0.1198,0.2301],[0.1198,0.2301],[0.1198,0.2302],[0.1198,0.2305],[0.1198,0.2309],[0.1198,0.2318],[0.1199,0.2327],[0.1201,0.2339],[0.1202,0.2351],[0.1204,0.2367],[0.1205,0.238],[0.1207,0.2396],[0.1208,0.2415],[0.1209,0.2439],[0.1211,0.2466],[0.1212,0.2494],[0.1213,0.2527],[0.1216,0.2567],[0.1218,0.2609],[0.1222,0.2655],[0.1225,0.2712],[0.1229,0.2772],[0.1233,0.2835],[0.1237,0.2904],[0.124,0.2977],[0.1242,0.3055],[0.1233,0.3136],[0.1222,0.3216],[0.121,0.3292],[0.1198,0.3363],[0.1186,0.342],[0.1174,0.3463],[0.1161,0.3492],[0.116,0.3519],[0.116,0.3536],[0.116,0.3551],[0.116,0.357],[0.116,0.3589],[0.116,0.36],[0.116,0.3611],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621],[0.116,0.3621]],"bottle":[0.0868,0.6212]};
    var N = A.pod.length, ASPECT = 1060 / 1584, CX = 0.297;     /* product centre, fraction of the canvas width */
    var POD_COL = 0.475, AD_MIN = 1;   /* the pod's label stands clear of the adapter's widest point (0.463), where the pod ends up */
    A.adapter.forEach(function (p) { AD_MIN = Math.min(AD_MIN, p[0]); });
    var tpl = cv.getAttribute('data-src');
    var L = [
      { el: document.getElementById('annoPod'), side: 'r', at: function (i) { return A.pod[i]; } },
      { el: document.getElementById('annoHolder'), side: 'l', at: function (i) { return A.adapter[i]; } },
      { el: document.getElementById('annoBottle'), side: 'l', at: function () { return A.bottle; } }
    ];
    var lines = svg.querySelectorAll('line'), dots = svg.querySelectorAll('circle');
    var set = null, imgs = new Array(N), ok = new Array(N), started = false, shown = -1, want = 0;
    var EX = 0, GROW = 0, BASE = 0, W = 0, H = 0, X0 = 0, G = 40, LINE = 34, OFF = 7, dpr = 1, curF = 0;
    var POD_X = 0; A.pod.forEach(function (p) { POD_X = Math.max(POD_X, p[0]); });
    var stacked = function () { return window.matchMedia('(max-width: 900px)').matches; };
    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function src(i) { return tpl.replace('{s}', set).replace('{n}', ('00' + (i + 1)).slice(-3)); }

    function load(i) {
      if (imgs[i]) return;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { ok[i] = true; if (Math.abs(i - want) <= Math.abs(nearest(want) - want)) draw(want, true); };
      im.src = src(i);
      imgs[i] = im;
    }
    function nearest(i) {                           /* the closest frame that has arrived, so the canvas never blanks */
      if (ok[i]) return i;
      for (var d = 1; d < N; d++) { if (i - d >= 0 && ok[i - d]) return i - d; if (i + d < N && ok[i + d]) return i + d; }
      return -1;
    }
    function start() {                              /* coarse pass first (every 6th, then every 3rd), then the rest */
      if (started) return; started = true;
      [6, 3, 1].forEach(function (step) { for (var i = 0; i < N; i += step) load(i); });
      load(N - 1);
    }

    function layout() {
      set = set || (stacked() ? 'm' : 'd');
      LINE = stacked() ? 20 : 34;                    /* every label gets the same visible leader (Sam, 24 Sep) */
      OFF = stacked() ? 5 : 7;                        /* the dot stands just off the part, never touching it (Sam, 24 Sep) */
      G = OFF + LINE + 13;                           /* dot offset + 5px clear of the dot + the line + 8px clear of the text */
      var sw = stage.clientWidth, sr = stage.getBoundingClientRect(), vw = document.documentElement.clientWidth;
      var copy = section.querySelector('.hero-copy');
      /* room either side of the stage centre that a label may use: into the grid gap (never the copy), or to the window edge */
      var cx = sr.left + sw / 2;
      var leftLimit = stacked() ? 10 : Math.max(copy ? copy.getBoundingClientRect().right + 16 : 0, 10);
      var roomL = cx - leftLimit, roomR = vw - 12 - cx;
      var hMax = !stacked() ? Math.min(window.innerHeight - 190, 720)
        : reduced ? Math.min(window.innerHeight * 0.62, 560)
        : Math.min((BASE = wrap.clientHeight - GROW) / 0.87 * 1.1, 720);   /* room under the copy, +10% (v22.24) */
      var w = hMax * ASPECT;
      var target = w;
      function fit() {
        var lwPod = L[0].el.offsetWidth, lwAd = L[1].el.offsetWidth, lwBt = L[2].el.offsetWidth;
        return Math.min(target,
          (roomR - 10 - lwPod) / (POD_COL - CX),
          (roomR - G - lwPod) / Math.max(POD_X - CX, 0.01),
          (roomL - G - lwAd) / Math.max(CX - AD_MIN, 0.01),
          (roomL - G - lwBt) / Math.max(CX - A.bottle[0], 0.01));
      }
      var SH = 0;
      if (stacked()) {                               /* the left labels bind first on phones: let the product sit right of centre if that buys a larger render */
        var best = -1;
        for (var d = 0; d <= 60; d += 2) { roomL = cx + d - leftLimit; roomR = vw - 12 - cx - d; var ww = Math.min(fit(), target); if (ww > best + 0.5) { best = ww; SH = d; } }
        roomL = cx + SH - leftLimit; roomR = vw - 12 - cx - SH;
      }
      /* tight windows: first drop the labels' second line, then let them wrap, before the render itself shrinks */
      stage.classList.remove('asm-compact', 'asm-wrap');
      w = fit();
      if (w < target * 0.86) { stage.classList.add('asm-compact'); w = fit(); }
      if (w < target * 0.86) { stage.classList.add('asm-wrap'); w = fit(); }
      w = Math.max(w, 200 * ASPECT);
      W = Math.round(w); H = Math.round(w / ASPECT);
      X0 = Math.round(sw / 2 + SH - CX * W);
      wrap.style.setProperty('--asm-h', H + 'px');
      if (stacked() && !reduced) {                     /* 3x the v1 gaps: note to pod top (10px + the frame's top rows), bottle to band */
        var ta = Math.round(2 * (10 + H * 10 / 744)), ba = Math.round(2 * H * 0.061);
        var need = ta + Math.round(H * 0.87) + ba - BASE;   /* how much taller than the screen the panel must be */
        if (need < 0) { ta += Math.round(-need / 2); need = 0; }   /* capped render (tablets): share the spare height above and below */
        GROW = need - ta - ba; EX = need;
        section.style.setProperty('--asm-top-add', ta + 'px'); section.style.setProperty('--asm-bot-add', ba + 'px'); section.style.setProperty('--asm-grow', GROW + 'px');
      } else { ['--asm-top-add', '--asm-bot-add', '--asm-grow'].forEach(function (k) { section.style.removeProperty(k); }); EX = GROW = 0; }
      cv.style.width = W + 'px'; cv.style.height = H + 'px'; cv.style.left = X0 + 'px';
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      shown = -1;
    }

    function anchor(l, f) {                          /* between frames, glide: interpolate the (smoothed) anchors */
      var i0 = Math.max(0, Math.min(N - 1, Math.floor(f))), i1 = Math.min(N - 1, i0 + 1), t = Math.max(0, Math.min(1, f - i0));
      var a = l.at(i0), b = l.at(i1);
      return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
    }
    function place(f) {
      L.forEach(function (l, k) {
        var a = anchor(l, f), x = X0 + a[0] * W, y = a[1] * H;
        var el = l.el, w = el.offsetWidth, first = el.querySelector('.anno-strong');
        var lh = first ? first.offsetHeight : 16;
        var lx = l.side === 'r' ? Math.max(X0 + POD_COL * W + 10, x + G) : x - G - w;
        el.style.transform = 'translate(' + lx.toFixed(1) + 'px,' + (y - lh / 2).toFixed(1) + 'px)';
        var ln = lines[k], dt = dots[k];
        var dx = l.side === 'r' ? x + OFF : x - OFF;
        ln.setAttribute('x1', (l.side === 'r' ? dx + 5 : dx - 5).toFixed(1)); ln.setAttribute('y1', y.toFixed(1));
        ln.setAttribute('x2', (l.side === 'r' ? lx - 8 : lx + w + 8).toFixed(1)); ln.setAttribute('y2', y.toFixed(1));
        dt.setAttribute('cx', dx.toFixed(1)); dt.setAttribute('cy', y.toFixed(1));
      });
    }

    function draw(i, force) {
      want = i;
      var j = nearest(i);
      var f = j === i ? curF : j;                    /* labels glide with the scroll; if a frame is still loading, they wait with the picture */
      if (j < 0) { place(curF); return; }
      if (j === shown && !force) { place(f); return; }
      shown = j;
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.drawImage(imgs[j], 0, 0, cv.width, cv.height);
      place(f);
    }

    function progress() {
      var t = section.getBoundingClientRect().top + EX, total = section.offsetHeight - window.innerHeight - EX;
      return total > 40 ? clamp01(-t / (total * USE)) : 1;   /* done at ~5/6 of the runway, so the finished bottle rests */
    }

    /* ---- snap (Will's v2): two journeys, the adapter (frames 1-49) then the pod (49-90). Scroll drives the frame
       directly; when scrolling rests past half of a journey, the page eases on to its end so the product never hovers
       almost-closed. Scrolling up mirrors it. Any wheel, touch, key or click cancels the ease. ---- */
    var USE = 0.84, SEG = [[0, 48], [48, N - 1]], THR = 0.5;
    var tween = 0, idle = 0, lastY = window.pageYOffset, dir = 1;
    function frameToY(f) {
      var p = f / (N - 1);
      var total = section.offsetHeight - window.innerHeight - EX;
      return section.getBoundingClientRect().top + window.pageYOffset + EX + p * total * USE;
    }
    function jump(y) { try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); } }   /* the site scrolls smoothly by default; the ease is ours */
    function cancelTween() { if (tween) { cancelAnimationFrame(tween); tween = 0; } }
    function easeTo(y) {
      cancelTween();
      if (reduced) { jump(y); return; }
      var y0 = window.pageYOffset, d = y - y0, ms = Math.min(700, Math.max(300, 250 + Math.abs(d) * 0.25)), t0 = performance.now();
      (function step(now) {
        var t = Math.min(1, (now - t0) / ms), e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        jump(y0 + d * e);
        tween = t < 1 ? requestAnimationFrame(step) : 0;
      })(t0);
    }
    function maybeSnap() {
      if (tween || !section.offsetParent) return;
      var f = progress() * (N - 1);
      if (f <= 0.01 || f >= N - 1.01) return;
      var seg = null;
      SEG.forEach(function (s) { if (f > s[0] && f < s[1]) seg = s; });
      if (!seg) return;
      var local = (f - seg[0]) / (seg[1] - seg[0]), target = null;
      if (dir > 0 && local > THR) target = seg[1];
      if (dir < 0 && local < 1 - THR) target = seg[0];
      if (target === null || Math.abs(target - f) < 0.75) return;
      easeTo(frameToY(target));
    }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, cancelTween, { passive: true }); });

    var ticking = false;
    function onScroll() {
      var y = window.pageYOffset;
      if (y !== lastY) dir = y > lastY ? 1 : -1;
      lastY = y;
      if (!tween) { clearTimeout(idle); idle = setTimeout(maybeSnap, 150); }
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!section.offsetParent) return;          /* page not showing */
        curF = progress() * (N - 1);
        draw(Math.round(curF));
      });
    }
    function onResize() { if (!section.offsetParent) return; layout(); curF = reduced ? N - 1 : progress() * (N - 1); draw(Math.round(curF), true); }

    function reveal() {                              /* labels arrive once, bottle first, as the stage comes into view */
      stage.classList.add('on');
      L.slice().reverse().forEach(function (l, k) { setTimeout(function () { l.el.classList.add('on'); }, reduced ? 0 : 120 * k); });
    }

    function init() {
      if (!section.offsetParent) return false;
      layout();
      if (reduced) { load(N - 1); curF = N - 1; draw(N - 1, true); reveal(); return true; }
      load(0);
      curF = progress() * (N - 1);
      draw(Math.round(curF), true);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { if (es[0].isIntersecting) start(); }, { rootMargin: '200% 0px' }).observe(section);
        new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { reveal(); o.disconnect(); } }, { threshold: 0.35 }).observe(stage);
      } else { start(); reveal(); }
      window.addEventListener('scroll', onScroll, { passive: true });
      return true;
    }
    window.addEventListener('resize', onResize, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (stacked() && !reduced) onResize(); }).observe(wrap);
    /* the section may start hidden (another page showing); try again whenever the route changes */
    if (!init()) {
      var retry = function () { if (init()) { window.removeEventListener('hashchange', retry); window.removeEventListener('bb:route', retry); } };
      window.addEventListener('hashchange', function () { setTimeout(retry, 60); });
      window.addEventListener('bb:route', retry);
    } else {
      window.addEventListener('hashchange', function () { setTimeout(onResize, 60); });
    }
    window.__asm = { draw: draw, layout: layout, progress: progress, N: N };   /* test hook */
  })();


  /* ---------- SCIENCE: Our research - the film beside the five steps (v22.25) ---------- */
  (function () {
    var sec = document.getElementById('sciResearch'); if (!sec) return;
    var vid = sec.querySelector('.rs-video'), film = sec.querySelector('.rs-film'), btn = sec.querySelector('.rs-toggle');
    var chip = sec.querySelector('.rs-chip'), chipNo = sec.querySelector('.rs-chip-no'), chipName = sec.querySelector('.rs-chip-name');
    var steps = Array.prototype.slice.call(sec.querySelectorAll('.rs-step'));
    var segs = Array.prototype.slice.call(sec.querySelectorAll('.rs-segs i'));
    var names = steps.map(function (li) { return li.querySelector('.rs-title').textContent.replace(/\.$/, ''); });
    var userPaused = reduced, onScreen = false, cur = 0, swapT = 0;
    sec.classList.add('rs-live');
    var rises = Array.prototype.slice.call(sec.querySelectorAll('.rs-rise'));   /* v22.26: each step rises as it enters */
    if (reduced || !('IntersectionObserver' in window)) rises.forEach(function (li) { li.classList.add('in'); });
    else {
      var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
      rises.forEach(function (li) { rio.observe(li); });
    }

    function sync() {                                   /* play only when on screen and not paused by the reader */
      if (onScreen && !userPaused) { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!vid.paused) vid.pause();
    }
    function paintBtn() {
      var paused = vid.paused;
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
    }
    vid.addEventListener('play', paintBtn); vid.addEventListener('pause', paintBtn); paintBtn();
    btn.addEventListener('click', function () { userPaused = !vid.paused; if (!userPaused) onScreen = true; sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(film);
    } else { onScreen = true; sync(); }

    function activate(i) {
      if (i === cur) return; cur = i;
      steps.forEach(function (li, k) { li.classList.toggle('on', k === i); });
      segs.forEach(function (g, k) { g.classList.toggle('on', k === i); });
      clearTimeout(swapT); chip.classList.add('swap');
      swapT = setTimeout(function () { chipNo.textContent = (i < 9 ? '0' : '') + (i + 1); chipName.textContent = names[i]; chip.classList.remove('swap'); }, reduced ? 0 : 180);
    }
    var ticking = false;
    function pick() {                                   /* the step that has crossed the middle of the window */
      ticking = false;
      if (!sec.offsetParent) return;
      var mid = window.innerHeight * 0.52, i = 0;
      steps.forEach(function (li, k) { if (li.getBoundingClientRect().top < mid) i = k; });
      activate(i);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(pick); } }, { passive: true });
    window.addEventListener('resize', pick, { passive: true });
    window.addEventListener('hashchange', function () { setTimeout(pick, 80); });
    pick();
  })();

  /* ---------- MEET THE RESIDENTS: carousel ---------- */
  (function () {
    var track = document.getElementById('resTrack'); if (!track) return;
    var carousel = track.closest('.res-carousel');
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(document.querySelectorAll('#resDots .res-dot'));
    var prev = document.getElementById('resPrev'), next = document.getElementById('resNext'), idxEl = document.getElementById('resIdx');
    var cur = 0;
    function padL() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function slideX(i) { return slides[i].offsetLeft - track.offsetLeft - padL(); }
    function atEnd() { return track.clientWidth > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }   /* the page may still be hidden at load */
    function paint() {
      dots.forEach(function (d, i) { d.classList.toggle('on', i === cur); d.setAttribute('aria-selected', i === cur ? 'true' : 'false'); });
      idxEl.textContent = (cur + 1 < 10 ? '0' : '') + (cur + 1);
      prev.classList.toggle('is-hidden', cur === 0);
      next.classList.toggle('is-hidden', cur === slides.length - 1 || atEnd());
      carousel.classList.toggle('has-prev', cur > 0);
      carousel.classList.toggle('at-end', cur === slides.length - 1 || atEnd());
    }
    function goTo(i) {
      cur = Math.max(0, Math.min(slides.length - 1, i)); paint();          /* controls answer at once; the track follows */
      track.scrollTo({ left: slideX(cur), behavior: reduced ? 'auto' : 'smooth' });
    }
    function sync() {                                                        /* after a swipe, read where the track settled */
      var x = track.scrollLeft, best = 0, bd = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs(slideX(i) - x); if (d < bd) { bd = d; best = i; } });
      if (atEnd()) best = slides.length - 1;
      if (best !== cur) cur = best;
      paint();
    }
    prev.addEventListener('click', function () { goTo(cur - 1); });
    next.addEventListener('click', function () { goTo(cur + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.getAttribute('data-i')); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); } });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 90); }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', sync);
    window.addEventListener('resize', function () { goTo(cur); });
    paint();
    /* neighbours not yet (or no longer) in view sit back a little */
    if ('IntersectionObserver' in window) {
      var aio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('is-away', en.intersectionRatio < 0.75); });
        paint();                                                             /* also fires when the page first shows */
      }, { root: track, threshold: [0, 0.5, 0.75, 1] });
      slides.forEach(function (sl) { aio.observe(sl); });
    }
  })();

  /* ---------- MEET THE RESIDENTS: on phones the paragraph shows its first ~60%, a plus reveals the rest ---------- */
  (function () {
    var paras = document.querySelectorAll('.specimen-card figcaption p');
    if (!paras.length) return;
    var mq = window.matchMedia('(max-width: 720px)');
    paras.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'res-more'; btn.hidden = true; btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="res-more-ico" aria-hidden="true"></span><span class="res-more-lbl">Read more</span>';
      p.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        var open = !p.classList.contains('is-open');
        p.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.res-more-lbl').textContent = open ? 'Show less' : 'Read more';
      });
    });
    function clampAll() {
      paras.forEach(function (p) {
        var btn = p.nextElementSibling;
        if (!mq.matches) { p.style.maxHeight = ''; p.classList.remove('is-clamped'); btn.hidden = true; return; }
        if (!p.offsetParent) return;                                   /* page hidden at load: measured again on first show */
        var lh = parseFloat(getComputedStyle(p).lineHeight) || 24;
        var prev = p.style.maxHeight; p.style.maxHeight = 'none';
        var lines = Math.round(p.scrollHeight / lh);
        p.style.maxHeight = prev;
        var keep = Math.max(3, Math.round(lines * 0.6));
        if (lines <= keep + 1) { p.style.maxHeight = ''; p.classList.remove('is-clamped'); btn.hidden = true; return; }
        p.style.maxHeight = (keep * lh) + 'px';
        p.classList.toggle('is-clamped', !p.classList.contains('is-open'));
        btn.hidden = false;
      });
    }
    clampAll();
    window.addEventListener('resize', clampAll);
    if ('IntersectionObserver' in window) {
      var once = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { clampAll(); once.disconnect(); } }); });
      once.observe(paras[0]);
    }
    window.__resClamp = clampAll;   /* test hook */
  })();

  /* ---------- NAV: quiet wide bar condenses into the floating pill ---------- */
  var nav = document.querySelector('.nav');
  function navState() { nav.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', navState, { passive: true });
  navState();

  /* ---------- MOBILE MENU ---------- */
  (function () {
    var btn = document.querySelector('.nav-menu-btn'), menu = document.getElementById('mobileMenu');
    if (!btn || !menu) return;
    btn.hidden = false;
    var closing = false;
    function openMenu() {
      menu.hidden = false; void menu.offsetWidth;
      menu.classList.remove('is-closing'); menu.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      if (menu.hidden || closing) return;
      closing = true;
      menu.classList.remove('is-open'); menu.classList.add('is-closing');
      btn.setAttribute('aria-expanded', 'false');
      var done = function () { menu.classList.remove('is-closing'); menu.hidden = true; closing = false; };
      if (reduced) done(); else setTimeout(done, 150);
    }
    btn.addEventListener('click', function () { menu.hidden ? openMenu() : closeMenu(); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { closeMenu(); }); });
    document.addEventListener('click', function (e) { if (!menu.hidden && !menu.contains(e.target) && !btn.contains(e.target)) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { closeMenu(); btn.focus(); } });
    window.addEventListener('hashchange', closeMenu);
    window.__menu = { open: openMenu, close: closeMenu };
  })();

  /* ---------- FOUNDERS: word reveal, dial draw, count-up ---------- */
  document.querySelectorAll('[data-word-reveal]').forEach(function (quote) {
    var accent = quote.getAttribute('data-accent');
    var quoteWords = quote.textContent.split(/\s+/).filter(Boolean);
    quote.textContent = '';
    quoteWords.forEach(function (word, i) {
      var s = document.createElement('span');
      s.className = 'w' + (word === accent ? ' accent-w' : '');
      s.style.setProperty('--i', i);
      s.textContent = word;
      quote.appendChild(s);
      quote.appendChild(document.createTextNode(' '));
    });
  });

  function countUp(el) {
    var to = parseInt(el.getAttribute('data-count'), 10);
    var from = parseInt(el.getAttribute('data-from') || '0', 10);
    var suffix = el.getAttribute('data-suffix') || '';
    var t0 = null;
    var DUR = 1300;
    function tick(t) {
      if (!t0) t0 = t;
      var k = Math.min((t - t0) / DUR, 1);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(from + (to - from) * e) + suffix;
      if (k < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        if (en.target.classList.contains('moment')) { en.target.parentNode.querySelectorAll('.moment').forEach(function (m) { m.classList.add('in'); }); }
        en.target.querySelectorAll('.dial-num[data-count], .mission-num[data-count]').forEach(countUp);
        if (en.target.id === 'oxyChart' && window.__oxyEnsure) window.__oxyEnsure();   /* v22.26: draw only once it is well in view */
        io.unobserve(en.target);
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fx, [data-word-reveal], .dial, .founders-photo').forEach(function (el) { io.observe(el); });
    /* Belt and braces for the chart: it is moved between pages by the router, and some engines stop observing a
       re-parented target. If it is on screen and still undrawn, draw it from the scroll position. */
    (function () {
      var ch = document.getElementById('oxyChart'); if (!ch) return;
      var busy = false;
      function ensure() {
        if (ch.hasAttribute('data-drawn')) { window.removeEventListener('scroll', onS); return; }
        if (!ch.offsetParent) return;
        var r = ch.getBoundingClientRect(), vh = window.innerHeight;
        var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0);   /* v22.26: most of the chart on screen, so the growth is seen */
        if (r.bottom > 0 && vis >= Math.min(r.height * 0.7, vh * 0.55)) {
          ch.classList.add('in'); ch.setAttribute('data-drawn', '');
          drawOxy(document.querySelector('.oxy-chip.on').getAttribute('data-set'), true);
          window.removeEventListener('scroll', onS);
        }
      }
      function onS() { if (busy) return; busy = true; setTimeout(function () { busy = false; ensure(); }, 80); }
      window.addEventListener('scroll', onS, { passive: true });
      window.addEventListener('hashchange', function () { setTimeout(ensure, 60); });
      setTimeout(ensure, 400);
      var poll = setInterval(function () { if (ch.hasAttribute('data-drawn')) clearInterval(poll); else ensure(); }, 600);
      window.__oxyEnsure = ensure;   /* test hook */
    })();
  } else {
    document.querySelectorAll('.fx, [data-word-reveal], .dial, .founders-photo').forEach(function (el) { el.classList.add('in'); });
    setTimeout(function () { drawOxy('bacteria', false); }, 0); /* defer: chart vars assigned later in this scope */
  }

  var vid = document.querySelector('.founders-video');
  if (vid) {
    if (reduced) {
      vid.removeAttribute('autoplay');
      vid.pause();
    } else {
      vid.muted = true; /* the attribute alone doesn't always satisfy autoplay policy */
      var vp = vid.play();
      if (vp && vp.catch) vp.catch(function () {});
    }
  }

  /* ---------- BLOG: home + post template (v22.27; stage 2 becomes Shopify's blog/article templates) ---------- */
  (function () {
    var data = document.getElementById('bbPosts'); if (!data) return;
    var POSTS = JSON.parse(data.textContent);
    var CATS = ['Science', 'Interviews', 'Awards', 'Funding'];
    var cur = 'All', built = false;
    function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function fmt(d) { try { return new Date(d + 'T12:00:00Z').toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return d; } }
    function meta(p) { return '<div class="bmeta"><span class="bchip">' + esc(p.cat) + '</span><span class="data">' + p.mins + ' min read</span></div>'; }
    function card(p) {
      return '<a class="bcard" href="#post/' + p.slug + '" data-cat="' + esc(p.cat) + '"><div class="bcard-img"><img src="' + p.thumb + '" alt="" decoding="async"></div>' +
        meta(p) + '<h3 class="bcard-title">' + esc(p.title) + '</h3><p class="bcard-ex">' + esc(p.desc) + '</p><span class="data bcard-date">' + fmt(p.date) + '</span></a>';
    }
    function feature(p) {
      return '<a class="blog-feature" href="#post/' + p.slug + '"><div class="blog-feature-img"><img src="' + p.cover + '" alt=""></div><div class="blog-feature-body">' +
        meta(p) + '<h2 class="blog-feature-title">' + esc(p.title) + '</h2><p class="blog-feature-ex">' + esc(p.desc) + '</p>' +
        '<span class="blog-feature-cta">Read the post&nbsp;&rarr;</span></div></a>';
    }
    function paint() {
      var list = cur === 'All' ? POSTS.slice(1) : POSTS.filter(function (p) { return p.cat === cur; });
      document.getElementById('blogFeature').style.display = cur === 'All' ? '' : 'none';
      var g = document.getElementById('blogGrid');
      g.innerHTML = list.map(card).join('');
      if (!reduced) {
        var cards = g.querySelectorAll('.bcard');
        cards.forEach(function (c) { c.classList.add('enter'); });
        requestAnimationFrame(function () { requestAnimationFrame(function () { cards.forEach(function (c, i) { setTimeout(function () { c.classList.remove('enter'); }, Math.min(i, 8) * 45); }); }); });
      }
      document.querySelectorAll('.bfilter').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cat') === cur ? 'true' : 'false'); });
    }
    window.__bbBlog = function () {
      if (built) return; built = true;
      document.getElementById('blogFeature').innerHTML = feature(POSTS[0]);
      var f = document.getElementById('blogFilter');
      f.innerHTML = ['All'].concat(CATS).map(function (c) {
        var n = c === 'All' ? POSTS.length : POSTS.filter(function (p) { return p.cat === c; }).length;
        return '<button class="bfilter" type="button" data-cat="' + c + '" aria-pressed="false">' + c + '<span class="n">' + n + '</span></button>';
      }).join('');
      f.addEventListener('click', function (e) { var b = e.target.closest('.bfilter'); if (!b) return; cur = b.getAttribute('data-cat'); paint(); });
      paint();
    };

    /* ---- the post ---- */
    var heads = [], tocLinks = [];
    function initials(n) { return (n || 'B').split(/\s+/).map(function (w) { return w[0]; }).join('').slice(0, 2).toUpperCase(); }
    window.__bbPost = function (slug) {
      var p = POSTS.filter(function (x) { return x.slug === slug; })[0] || POSTS[0];
      document.getElementById('postCat').textContent = p.cat;
      document.getElementById('postTitle').textContent = p.title;
      document.getElementById('postDesc').textContent = p.desc;
      document.getElementById('postAuthor').textContent = p.author === 'Booby Biome' ? 'The BoobyBiome team' : p.author;
      document.getElementById('postAvatar').textContent = p.author === 'Booby Biome' ? 'B' : initials(p.author);
      document.getElementById('postMeta').textContent = fmt(p.date) + ' \u00b7 ' + p.mins + ' min read';
      var hero = document.getElementById('postHero'); hero.src = p.cover;
      var body = p.body;
      if (p.cat === 'Science') body += '<p class="post-note">This post is for information only and is not medical advice. Please talk to your midwife, health visitor or GP about feeding decisions for your baby.</p>';
      if (p.press) body += '<div class="post-press"><span class="eyebrow eyebrow--sm">Press enquiries</span><a href="mailto:info@boobybiome.com">info@boobybiome.com</a></div>';
      var el = document.getElementById('postBody'); el.innerHTML = body;
      heads = Array.prototype.slice.call(el.querySelectorAll('h2[id]'));
      var toc = document.getElementById('postToc');
      toc.innerHTML = heads.map(function (h) { return '<li><a href="#' + h.id + '" data-to="' + h.id + '">' + esc(h.textContent) + '</a></li>'; }).join('');
      document.getElementById('postTocWrap').style.display = heads.length >= 2 ? '' : 'none';
      tocLinks = Array.prototype.slice.call(toc.querySelectorAll('a'));
      var more = POSTS.filter(function (x) { return x.slug !== p.slug && x.cat === p.cat; });
      more = more.concat(POSTS.filter(function (x) { return x.slug !== p.slug && x.cat !== p.cat; })).slice(0, 3);
      document.getElementById('postMore').innerHTML = more.map(card).join('');
      var url = location.href;
      document.querySelectorAll('[data-share="linkedin"]').forEach(function (a) { a.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url); });
      document.querySelectorAll('[data-share="email"]').forEach(function (a) { a.href = 'mailto:?subject=' + encodeURIComponent(p.title) + '&body=' + encodeURIComponent(url); });
      progress();
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.post-toc a[data-to]');
      if (t) { e.preventDefault(); var h = document.getElementById(t.getAttribute('data-to')); if (h) h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); return; }
      var c = e.target.closest('[data-share="copy"]');
      if (c) {
        var done = c.parentNode.querySelector('.share-done');
        var ok = function () { done.textContent = 'Link copied'; done.classList.add('on'); setTimeout(function () { done.classList.remove('on'); }, 1800); };
        try { navigator.clipboard.writeText(location.href).then(ok, ok); } catch (err) { ok(); }
      }
    });
    var bar = document.getElementById('readBar'), art = document.getElementById('postArticle'), tick = false;
    function progress() {
      tick = false;
      if (document.body.getAttribute('data-route') !== 'post') return;
      var body = document.getElementById('postBody').getBoundingClientRect(), vh = window.innerHeight;
      var k = Math.max(0, Math.min(1, (vh * 0.35 - body.top) / Math.max(1, body.height - vh * 0.4)));
      bar.style.transform = 'scaleX(' + k.toFixed(4) + ')';
      var on = -1; heads.forEach(function (h, i) { if (h.getBoundingClientRect().top < vh * 0.3) on = i; });
      tocLinks.forEach(function (a, i) { a.classList.toggle('on', i === on); });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(progress); } }, { passive: true });
    window.addEventListener('resize', progress, { passive: true });
  })();

  /* ---------- BYOMI USER INSTRUCTIONS: the film + the full IFU in English / Espanol (v22.35) ---------- */
  (function () {
    var root = document.getElementById('ifuRoot'); if (!root) return;
    var v = document.getElementById('howtoVideo'), film = document.getElementById('howtoFilm'), play = document.getElementById('howtoPlay');
    if (v && play) {
      play.addEventListener('click', function () { v.setAttribute('controls', ''); film.classList.add('playing'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      (function () {                                    /* captions: the WebVTT text sits inline; turn it into a track, on by default */
        var src = document.getElementById('howtoCaptions'); if (!src || !v.addTextTrack || !window.VTTCue) return;
        var tr = v.addTextTrack('captions', 'English', 'en');
        function sec(x) { var p = x.split(':').map(parseFloat); return p.length === 3 ? p[0] * 3600 + p[1] * 60 + p[2] : p[0] * 60 + p[1]; }
        src.textContent.replace(/\r/g, '').split(/\n\n+/).forEach(function (blk) {
          var m = blk.match(/([0-9:.]+)\s*--\x3e\s*([0-9:.]+)[^\n]*\n([\s\S]+)/);
          if (m) tr.addCue(new VTTCue(sec(m[1]), sec(m[2]), m[3].trim()));
        });
        tr.mode = 'showing';
      })();
      window.addEventListener('hashchange', function () { if (!v.paused) v.pause(); });
    }
    /* language: English is in the page; Spanish comes from this table (Claude's translation, to be reviewed) */
    var ES = {"pill": "Instrucciones de uso", "keep": "Conserva este folleto para futuras consultas.", "watch": "Ver el vídeo", "watch_sub": "54 s · en inglés, con sonido", "lang_label": "Idioma", "contents": "En esta página", "size_guide_btn": "Guía de tamaños", "howto_h": "Cómo se usa", "steps": ["Extrae tu leche", "Abre el envoltorio del Pod Byomi®", "Despega el aluminio para activarlo", "Encaja el Pod Byomi® en el Adaptador", "Coloca el set Byomi® en el biberón", "Fíjalo con el anillo de cierre", "Guárdalo en la nevera"], "before_h": "Antes de empezar", "before": [["En tu set", "Necesitarás tanto los Pods de conservación de leche materna Byomi® como los Adaptadores para biberón."], ["Antes del primer uso", "Saca los Adaptadores del estuche de viaje y esterilízalos en agua hirviendo durante un máximo de 3 minutos."], ["Retirar el set para la toma", "A medida que el Pod actúa, se forma un vacío parcial dentro del biberón, por lo que al principio el set puede notarse apretado. Usa el borde de agarre para levantar un lado del Adaptador y liberar el cierre."], ["Tu estuche de viaje", "Lávalo a mano o en el lavavajillas. No lo esterilices en agua hirviendo."], ["Después de cada uso", "Los Adaptadores deben esterilizarse entre usos con tu método de esterilización habitual."], ["Si el anillo de cierre no queda a ras", "En algunos biberones, el anillo de cierre no se enrosca hasta el fondo cuando el Adaptador está colocado. Aun así, cierra herméticamente y la leche no se saldrá."]], "pod_h": "Lo esencial del Pod", "pod_intro": "Los Pods Byomi® están diseñados para eliminar el oxígeno que reduce los antioxidantes, las bacterias beneficiosas y los omega-3 de la leche materna durante su conservación. El entorno sin oxígeno ayuda a conservar estos componentes y protege cada gota de tu leche materna.", "pod": ["Guarda los Pods en un lugar fresco y seco, protegidos de la luz solar directa.", "Guarda el biberón en posición vertical en la nevera. Para añadir leche al mismo biberón, retira el Pod, añade más leche y vuelve a colocar el Pod. Puedes hacerlo hasta tres veces en las 24 horas siguientes a la apertura del Pod. Reduce al mínimo la exposición del Pod al aire para que siga funcionando con eficacia.", "La temperatura de funcionamiento de los Pods está entre 1 °C (34 °F) y 40 °C (104 °F).", "No esterilices los Pods. Cada Pod viene envuelto individualmente y esterilizado.", "Es normal que el Pod se note caliente después de abrirlo. Es el polvo absorbiendo oxígeno."], "safety_h": "Información importante de seguridad", "safety": ["Mantén todos los componentes fuera del alcance de bebés y niños.", "No lo uses si observas cualquier signo de daño o deterioro. Sustituye los Adaptadores si se rasgan, se vuelven pegajosos, se agrietan, pierden el color o dejan de cerrar herméticamente.", "No esterilices los Pods Byomi®.", "No calientes el biberón en el microondas con un Pod colocado.", "No congeles los Pods.", "Sigue las recomendaciones nacionales sobre el tiempo máximo de conservación de la leche materna.", "Los Pods están diseñados para usarse con un solo biberón de leche materna conservada. No los reutilices en varios biberones para evitar la contaminación."], "badges": ["¡Advertencia!", "No comer", "No apto para microondas"], "measure_h": "Cómo medir tu biberón", "measure": "Si tu Adaptador no encaja en tu biberón, escríbenos a support@boobybiome.com. Nuestra guía de tamaños está en www.boobybiome.com; también puedes medir el diámetro interior de tu biberón con la guía de abajo.", "sizes": [["Pequeño", "de 31 mm a 33 mm"], ["Mediano", "de 44 mm a 47 mm"], ["Grande", "de 52 mm a 53 mm"]], "active_h": "Contiene material activo", "active": "El ingrediente activo es un absorbente de oxígeno a base de hierro. Elimina el oxígeno del aire del interior del biberón cerrado. El ingrediente activo está detrás de una barrera de membrana de doble capa y no entra en contacto con tu leche.", "disposal_h": "Eliminación", "disposal": "Recicla el embalaje exterior según las indicaciones de reciclaje incluidas. Desecha los Pods Byomi® usados con los residuos generales. Visita nuestra web para saber más sobre nuestro compromiso con la sostenibilidad.", "address": ["BoobyBiome Ltd.", "483 Green Lanes", "London", "N13 4FG", "United Kingdom"], "version": "V2"};
    var EN = {};
    function esc(x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function linkify(x) {
      return esc(x).replace('support@boobybiome.com', '<a href="mailto:support@boobybiome.com">support@boobybiome.com</a>')
                   .replace(/www\.boobybiome\.com/, '<a href="https://boobybiome.com/">www.boobybiome.com</a>');
    }
    function pick(tbl, key) { return key.split('.').reduce(function (o, k) { return o == null ? o : o[k]; }, tbl); }
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-i18n]'));
    els.forEach(function (el) { EN[el.getAttribute('data-i18n')] = el.innerHTML; });
    var navEl = root.querySelector('[data-i18n-aria]'), navEN = navEl ? navEl.getAttribute('aria-label') : '';
    var playEN = play ? play.getAttribute('aria-label') : '';
    function setLang(lang) {
      els.forEach(function (el) {
        var k = el.getAttribute('data-i18n');
        if (lang === 'es') { var x = pick(ES, k); if (typeof x === 'string') el.innerHTML = linkify(x); }
        else el.innerHTML = EN[k];
      });
      if (navEl) navEl.setAttribute('aria-label', lang === 'es' ? ES.contents : navEN);
      if (play) play.setAttribute('aria-label', lang === 'es' ? ES.watch : playEN);
      root.setAttribute('lang', lang);
      root.querySelectorAll('.ifu-lang-seg button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lang') === lang ? 'true' : 'false'); });
      try { localStorage.setItem('bb-ifu-lang', lang); } catch (e) {}
    }
    root.querySelectorAll('.ifu-lang-seg button').forEach(function (b) { b.addEventListener('click', function () { setLang(b.getAttribute('data-lang')); }); });
    root.querySelectorAll('.ifu-chip').forEach(function (a) {
      a.addEventListener('click', function (e) { var tgt = document.getElementById(a.getAttribute('href').slice(1)); if (tgt) { e.preventDefault(); tgt.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); } });
    });
    var start = 'en';
    try { var q = (location.search.match(/[?&]lang=(en|es)/) || [])[1]; start = q || localStorage.getItem('bb-ifu-lang') || 'en'; } catch (e) {}
    if (start === 'es') setLang('es');
  })();

  /* ---------- ROUTER: on Shopify each page is its own URL; the server sets data-route and data-light-top on <body> ---------- */
  function samePath(a) {
    var here = location.pathname.replace(/\/$/, '') || '/';
    var there = (a.pathname || '').replace(/\/$/, '') || '/';
    if (there === '/blogs/blog') return here.indexOf('/blogs/blog') === 0;   /* v22.38: Blog stays lit on posts and tag pages */
    return here === there;
  }
  function route() {
    document.querySelectorAll('.nav-links a, .nav-menu-link').forEach(function (a) { a.classList.toggle('active', samePath(a)); });
    if (typeof navState === 'function') navState();
    window.dispatchEvent(new Event('scroll'));
  }
  route();

  /* Footer "Donate milk" lands on the contact page pre-selected. Lives outside the contact block: on Shopify the
     footer exists on every page but the contact form only on /pages/contact (validator finding, 14 Sep). */
  document.querySelectorAll('a[href="/pages/contact"][data-topic]').forEach(function (a) {
    a.addEventListener('click', function () { try { sessionStorage.setItem('bb-contact-topic', a.getAttribute('data-topic')); } catch (e) {} });
  });

  /* Forms post to Shopify in the background so the on-page done state is unchanged; a spam challenge falls back to a normal submit. */
  function bbPost(form) {
    if (!form || !form.getAttribute('action')) return;
    try {
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' })
        .then(function (r) { if (r && r.url && r.url.indexOf('/challenge') !== -1) form.submit(); })
        .catch(function () { form.submit(); });
    } catch (e) { form.submit(); }
  }

  /* Waitlist sign-ups go to Klaviyo (list Waitlist, email marketing consent), so every subscriber lives in one place.
     Klaviyo Client API with the public site key; if it fails (blocked, offline, API error) the form falls back to the
     Shopify customer form, which the Klaviyo Shopify integration syncs into the same list. Added 24 Sep 2026. */
  var BB_KLAVIYO = { company: 'R5FkBK', list: 'WPTB7x', formId: 'UGHW6Z', revision: '2026-07-15' };
  function bbKlaviyo(form) {
    var input = form && form.querySelector('input[type="email"]');
    if (!input || !input.value) return;
    var source = form.id === 'bbWaitlistDialog' ? 'Website waitlist dialog' : 'Website footer waitlist';
    var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile',
      attributes: { email: input.value.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: BB_KLAVIYO.list } } } } };
    try {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + BB_KLAVIYO.company, {
        method: 'POST', headers: { 'content-type': 'application/vnd.api+json', revision: BB_KLAVIYO.revision }, body: JSON.stringify(body)
      }).then(function (r) { if (!r || !r.ok) bbPost(form); }).catch(function () { bbPost(form); });
    } catch (e) { bbPost(form); }
  }

  /* Waitlist buttons open the Klaviyo popup (custom trigger). If klaviyo.js has not loaded within 2.5s (ad blocker,
     slow network) the queued request is withdrawn and our own dialog opens instead, so the button never does nothing. */
  function bbKlaviyoReady() { return !!(window.klaviyo && typeof window.klaviyo.isIdentified === 'function'); }
  function bbOpenKlaviyoForm(fallback) {
    window._klOnsite = window._klOnsite || [];
    var cmd = ['openForm', BB_KLAVIYO.formId];
    window._klOnsite.push(cmd);
    if (bbKlaviyoReady()) return;
    setTimeout(function () {
      if (bbKlaviyoReady() || document.querySelector('.klaviyo-form')) return;
      var q = window._klOnsite, i = q && typeof q.indexOf === 'function' ? q.indexOf(cmd) : -1;
      if (i !== -1) q.splice(i, 1);
      fallback();
    }, 2500);
  }

  /* ---------- OXYGEN CHART: animated draw, switchable dataset ---------- */
  /* Both series start from the same point: fresh milk, nothing lost yet. Values are study means (2026, under review). */
  var OXY_DATA = {
    vitc: {
      type: 'bars',
      groups: [
        { label: '24 hours in the fridge', a: [21.2, 9.0], b: [12.8, 10.1] }
      ],
      barW: 120, gap: 60, err: false, barLabels: true,   /* one group, wide bars, no whiskers (Sam, 14 Sep); each bar named underneath (18 Sep) */
      yMax: 25, yTicks: [0, 5, 10, 15, 20, 25], yUnit: '\u00b5g/mL',   /* 0-25 (Sioned, 18 Sep) */
      yTitle: 'Vitamin C after 24 hours \u00b7 \u00b5g per mL',
      caption: 'Bars: vitamin C in \u00b5g per mL after 24 hours in the fridge.',
      flag: '*Mean values from our 2026 study, currently under peer review.'
    },
    petri: { type: 'petri', yTitle: '', caption: 'Four breast-milk strains of bifidobacteria held in air or with limited oxygen for four hours', flag: '*Data for illustrative purposes, adapted from BoobyBiome&rsquo;s 2026 study, currently under peer review. Average of four breast-milk strains (<i>B.&nbsp;infantis</i>, <i>B.&nbsp;longum</i>, <i>B.&nbsp;bifidum</i> and <i>B.&nbsp;breve</i>) held in air or with limited oxygen for four hours. Up to 25,987&times; more survived with limited oxygen.' },
    smell: { type: 'smell', yTitle: '', caption: 'Blind olfactory test after seven days in the fridge: 84% chose the milk stored with BYOMI', flag: '*From our 2026 study, currently under peer review.' },
    antiox: {
      a: 'M64.0,64.0 L650.0,65.1', b: 'M64.0,64.0 L650.0,108.3', pa: [[64.0, 64.0], [650.0, 65.1]], pb: [[64.0, 64.0], [650.0, 108.3]],
      divisions: 3, xStart: 'Fresh', xEnd: '3 days', pct: true,
      yTitle: 'Antioxidant capacity \u00b7 % of fresh milk',
      caption: 'Vertical axis: antioxidant capacity, % of fresh milk \u00b7 horizontal: days in the fridge'
    },
    bacteria: {
      /* Figure 3B: mean log10 change of B. longum, B. bifidum and B. breve (18 Sep), read from the figure by pixel colour.
         BYOMI 0 / -0.065 / -0.129 / -0.185; ordinary 0 / -0.108 / -1.056 / -2.014 at days 0/1/3/7.
         Axis 0 to -2.25: y = 22 + (-v / 2.25) * 278; x = 64 + 484 * day / 7. */
      a: 'M64.0,22.0 L133.1,30.0 L271.4,37.9 L548.0,44.9', b: 'M64.0,22.0 L133.1,35.3 L271.4,152.5 L548.0,270.9', pa: [[64.0, 22.0], [133.1, 30.0], [271.4, 37.9], [548.0, 44.9]], pb: [[64.0, 22.0], [133.1, 35.3], [271.4, 152.5], [548.0, 270.9]],
      logTicks: [[0, 22.0], [-1, 145.6], [-2, 269.1]],
      divisions: 7, xStart: 'Fresh', xEnd: '7 days', pct: true,
      ends: [['With', 'BYOMI'], ['Ordinary', 'bottle']],
      yTitle: 'Change in living bifidobacteria \u00b7 log\u2081\u2080 scale',
      caption: 'Vertical axis: change in living bifidobacteria on a log scale (0 = as fresh, \u22121 = a tenth remain, \u22122 = a hundredth remain) \u00b7 horizontal: days in the fridge',
      flag: '*Average of <i>B.&nbsp;longum</i>, <i>B.&nbsp;bifidum</i> and <i>B.&nbsp;breve</i>. From our 2026 study, currently under peer review.'
    }
  };
  var oxyEl = document.getElementById('oxyChart');
  var oxyP1 = document.getElementById('oxyP1');
  var oxyP2 = document.getElementById('oxyP2');
  var oxyT1 = document.getElementById('oxyT1');
  var oxyT2 = document.getElementById('oxyT2');
  var oxyXEnd = document.getElementById('oxyXEnd');
  var oxyYTitle = document.getElementById('oxyYTitle');
  var oxyYTicks = document.getElementById('oxyYTicks');
  var oxyTicks = document.getElementById('oxyTicks');
  var oxyRun = 0;
  var oxyPts = document.getElementById('oxyPts');
  var oxyXStart = document.getElementById('oxyXStart');
  var oxyGrid = document.getElementById('oxyGrid');
  var oxyXAxis = document.getElementById('oxyXAxis');
  var oxyEnds = document.getElementById('oxyEnds');
  function oxyAxes(d) {
    oxyXEnd.textContent = d.xEnd;
    if (oxyXStart) oxyXStart.textContent = d.xStart;
    /* measured points: small rings where the study actually took a reading */
    var pts = '';
    d.pa.forEach(function (p) { pts += '<circle class="pa" cx="' + p[0] + '" cy="' + p[1] + '" r="3.5"/>'; });
    d.pb.forEach(function (p) { pts += '<circle class="pb" cx="' + p[0] + '" cy="' + p[1] + '" r="3"/>'; });
    oxyPts.innerHTML = pts;
    oxyPts.style.opacity = 0;
    oxyYTitle.innerHTML = d.yTitle;
    var cap = document.getElementById('oxyCaption'); if (cap) cap.textContent = d.caption;
    oxyYTicks.style.opacity = d.pct ? 1 : 0;
    var XR = 548;                                   /* plot's right edge; the line labels sit beyond it */
    var yt = '', gr = '';
    (d.logTicks || [[100, 22], [0, 300]]).forEach(function (tk) {
      var lab = d.logTicks ? (tk[0] < 0 ? '\u2212' + (-tk[0]) : '0') : tk[0] + '%';
      yt += '<text class="oxy-lbl" x="56" y="' + (tk[1] + 4).toFixed(1) + '" text-anchor="end">' + lab + '</text>';
      if (tk[1] < 299) gr += '<line x1="64" y1="' + tk[1] + '" x2="' + XR + '" y2="' + tk[1] + '"/>';
    });
    oxyYTicks.innerHTML = yt;
    if (oxyGrid) oxyGrid.innerHTML = gr;
    if (oxyXAxis) oxyXAxis.setAttribute('x2', XR);
    oxyXEnd.setAttribute('x', XR);
    var t = '';
    for (var i = 1; i < d.divisions; i++) {       /* one quiet tick per day; only the ends are labelled */
      var x = (64 + (XR - 64) * i / d.divisions).toFixed(1);
      t += '<line x1="' + x + '" y1="300" x2="' + x + '" y2="306"/>';
    }
    oxyTicks.innerHTML = t;
    /* each line named at its end (18 Sep): no key to decode, and it reads on a phone */
    if (oxyEnds) {
      var e = '';
      if (d.ends) [[d.pa, 'a'], [d.pb, 'b']].forEach(function (sp, k) {
        var last = sp[0][sp[0].length - 1];
        e += '<text class="oxy-end oxy-end-' + sp[1] + '" x="' + (XR + 12) + '" y="' + last[1].toFixed(1) + '"><tspan x="' + (XR + 12) + '" dy="-0.2em">' + d.ends[k][0] + '</tspan><tspan x="' + (XR + 12) + '" dy="1.15em">' + d.ends[k][1] + '</tspan></text>';
      });
      oxyEnds.innerHTML = e;
    }
  }

  var oxyBars = document.getElementById('oxyBars');
  function drawBars(d, animate) {
    /* Grouped bars, mean ± SD, the way the study reports it. Plot: x 64..650, y 290 = 0, y 64 = yMax. */
    var Y0 = 300, Y1 = 22, W = d.barW || 62, GAP = d.gap || (d.barW ? 28 : 12);
    if (oxyXAxis) oxyXAxis.setAttribute('x2', 650);
    var yOf = function (v) { return Y0 - (v / d.yMax) * (Y0 - Y1); };
    var centres = d.groups.length === 1 ? [357] : [230, 484];   /* one group sits on the plot's centre line */
    var s = '';
    d.yTicks.forEach(function (t) {
      var yy = yOf(t).toFixed(1);
      s += '<text class="oxy-lbl" x="56" y="' + (parseFloat(yy) + 4).toFixed(1) + '" text-anchor="end">' + t + '</text>';
      if (t > 0) s += '<line x1="64" y1="' + yy + '" x2="650" y2="' + yy + '" stroke="rgba(31,74,74,0.08)" stroke-width="1"/>';
    });
    d.groups.forEach(function (g, i) {
      var cx = centres[i];
      [['a', cx - GAP / 2 - W, 'bar-a', 'err-a'], ['b', cx + GAP / 2, 'bar-b', 'err-b']].forEach(function (spec) {
        var v = g[spec[0]][0], sd = g[spec[0]][1], x0 = spec[1];
        var top = yOf(v), hgt = Y0 - top;
        s += '<rect class="bar ' + spec[2] + '" x="' + x0 + '" y="' + top.toFixed(1) + '" width="' + W + '" height="' + hgt.toFixed(1) + '" rx="3"/>';
        if (d.err !== false) {
          var mx = x0 + W / 2, yl = yOf(v - sd), yh = yOf(v + sd);
          s += '<path class="err ' + spec[3] + '" d="M' + mx + ',' + yl.toFixed(1) + ' V' + yh.toFixed(1) + ' M' + (mx - 7) + ',' + yh.toFixed(1) + ' H' + (mx + 7) + ' M' + (mx - 7) + ',' + yl.toFixed(1) + ' H' + (mx + 7) + '"/>';
        }
      });
      if (d.barLabels) {
        [[cx - GAP / 2 - W / 2, ['With', 'BYOMI']], [cx + GAP / 2 + W / 2, ['Ordinary', 'bottle']]].forEach(function (bl) {
          s += '<text class="oxy-lbl" x="' + bl[0] + '" y="322" text-anchor="middle"><tspan x="' + bl[0] + '">' + bl[1][0] + '</tspan><tspan x="' + bl[0] + '" dy="1.2em">' + bl[1][1] + '</tspan></text>';
        });
      } else {
        s += '<text class="oxy-lbl" x="' + cx + '" y="326" text-anchor="middle">' + g.label + '</text>';
      }
    });
    oxyBars.innerHTML = s;
    if (animate && !reduced) {
      oxyBars.classList.add('grow');
      void oxyBars.getBoundingClientRect();
      setTimeout(function () { oxyBars.classList.remove('grow'); }, 30);
    }
  }
  function drawOxy(key, animate) {
    if (!oxyEl) return;
    var d = OXY_DATA[key];
    var bars = d.type === 'bars', smell = d.type === 'smell';
    var svgEl = oxyEl.querySelector('svg'), keyEl = oxyEl.querySelector('.oxy-key'), smellEl = document.getElementById('oxySmell'), capEl = document.getElementById('oxyCaption');
    var flagEl = document.getElementById('oxyFlag'); if (flagEl && d.flag) flagEl.innerHTML = d.flag;
    var petri = d.type === 'petri', petriEl = document.getElementById('oxyPetri');
    if (svgEl) svgEl.style.display = smell || petri ? 'none' : '';
    if (keyEl) keyEl.style.display = smell || petri ? 'none' : '';
    if (capEl) capEl.style.display = smell || petri ? 'none' : '';   /* the footnote carries the petri view's description */
    if (petriEl) petriEl.hidden = !petri;
    if (window.__tk) { if (petri) window.__tk.show(animate); else window.__tk.stop(); }
    if (petri) {
      if (smellEl) { smellEl.classList.remove('show', 'in'); smellEl.hidden = true; }
      if (capEl) capEl.textContent = d.caption;
      return;
    }
    if (smellEl) {
      if (smell) {
        smellEl.hidden = false; smellEl.classList.add('show'); smellEl.classList.remove('in');
        void smellEl.offsetWidth;
        var go = function () {
          smellEl.classList.add('in');
          var c = smellEl.querySelector('.smell-count'); var to = +c.getAttribute('data-to');
          if (!animate || reduced) { c.textContent = to; return; }
          var t0 = null; var D = 1300;
          (function tick(t) { if (!t0) t0 = t; var k = Math.min((t - t0) / D, 1); c.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); })(performance.now());
        };
        if (!animate || reduced) go(); else setTimeout(go, 30);
        return;
      }
      smellEl.classList.remove('show', 'in'); smellEl.hidden = true;
    }
    [oxyP1, oxyP2, oxyT1, oxyT2, oxyPts, oxyTicks, oxyXStart, oxyXEnd, oxyYTicks, oxyGrid, oxyEnds].forEach(function (el) { if (el) el.style.display = bars ? 'none' : ''; });
    oxyBars.style.display = bars ? '' : 'none';
    oxyYTitle.textContent = d.yTitle;
    var cap0 = document.getElementById('oxyCaption'); if (cap0) cap0.textContent = d.caption;
    if (bars) { drawBars(d, animate); return; }
    oxyBars.innerHTML = '';
    oxyP1.setAttribute('d', d.a);
    oxyP2.setAttribute('d', d.b);
    oxyAxes(d);
    var runId = ++oxyRun;
    var pairs = [[oxyP1, oxyT1, 0], [oxyP2, oxyT2, 250]];
    if (!animate || reduced) {
      oxyPts.style.opacity = 1;
      pairs.forEach(function (pr) {
        pr[0].style.strokeDashoffset = 0; pr[0].style.strokeDasharray = 'none';
        var len = pr[0].getTotalLength();
        var pt = pr[0].getPointAtLength(len);
        pr[1].setAttribute('cx', pt.x); pr[1].setAttribute('cy', pt.y);
        pr[1].setAttribute('opacity', 1);
      });
      return;
    }
    var DUR = 1600;
    pairs.forEach(function (pr) {
      var path = pr[0], dot = pr[1], delay = pr[2];
      var len = path.getTotalLength();
      path.style.strokeDasharray = ''; path.style.strokeDashoffset = 1000;   /* back to the dashed reveal for this run */
      dot.setAttribute('opacity', 0);
      var t0 = null;
      function step(t) {
        if (runId !== oxyRun) return;               /* superseded by a newer run */
        if (!t0) t0 = t;
        var k = Math.min(Math.max((t - t0 - delay) / DUR, 0), 1);
        var e = easeInOut(k);
        path.style.strokeDashoffset = (1000 * (1 - e)).toFixed(1);
        if (k > 0) {
          var pt = path.getPointAtLength(len * e);
          dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
          dot.setAttribute('opacity', 1);
        }
        if (k < 1) requestAnimationFrame(step); else { path.style.strokeDasharray = 'none'; if (delay > 0) oxyPts.style.opacity = 1; }
      }
      requestAnimationFrame(step);
    });
    /* insurance: whatever happens to the frame loop, the finished state lands on a timer */
    setTimeout(function () {
      if (runId !== oxyRun) return;
      pairs.forEach(function (pr) {
        pr[0].style.strokeDashoffset = 0; pr[0].style.strokeDasharray = 'none';   /* a plain stroke: no dash maths left to go wrong on any engine */
        var len = pr[0].getTotalLength(), pt = pr[0].getPointAtLength(len);
        pr[1].setAttribute('cx', pt.x); pr[1].setAttribute('cy', pt.y); pr[1].setAttribute('opacity', 1);
      });
      oxyPts.style.opacity = 1;
    }, DUR + 250 + 200);
  }

  window.__drawOxy = drawOxy; /* test hook */

  /* ---------- OXYGEN IMPACT: time-kill time-lapse (Meg's "Science Behind Byomi" Figure 1 = study Figure 2, final) ----------
     Mean log10 change from the 10-min baseline, read from the study's vector figure. Aerobic sampled at 10/30/60/120/240 min;
     anaerobic at 10 and 240 min only, interpolated in a straight line between them, as in the figure. The plates show the
     average of the four strains: the arithmetic mean of the log10 changes (the geometric mean of the surviving fractions). */
  (function () {
    var svg = document.getElementById('tkPlates'); if (!svg) return;
    var TK = {
      infantis: { ae: [0, -0.023, -0.031, -2.054, -3.266], an: [0, -0.087] },
      longum:   { ae: [0, -0.044, -0.038, -2.639, -4.386], an: [0, 0.029] },
      bifidum:  { ae: [0, -0.020, -0.992, -3.316, -4.359], an: [0, 0.014] },
      breve:    { ae: [0, -0.048, -0.030, -2.000, -3.429], an: [0, 0.093] }
    };
    var ks = Object.keys(TK), AE = [], AN = [];
    for (var i = 0; i < 5; i++) AE.push(ks.reduce(function (m, k) { return m + TK[k].ae[i]; }, 0) / 4);
    for (var j = 0; j < 2; j++) AN.push(ks.reduce(function (m, k) { return m + TK[k].an[j]; }, 0) / 4);
    var T_AE = [10, 30, 60, 120, 240], T_AN = [10, 240], N = 420, DUR = 9000, NS = 'http://www.w3.org/2000/svg';
    var play = document.getElementById('tkPlay'), scrub = document.getElementById('tkScrub'), clock = document.getElementById('tkClock');
    var t = 10, raf = 0, playing = false;
    function el(tag, attrs, text) { var n = document.createElementNS(NS, tag); for (var a in attrs) n.setAttribute(a, attrs[a]); if (text) n.textContent = text; return n; }
    /* seeded random so both plates start identical and the layout is stable */
    var seed = 20260904;
    function rnd() { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; }
    var R = 118, cols = [], tries = 0;
    while (cols.length < N && tries < 60000) {
      tries++;
      var a = rnd() * Math.PI * 2, rr = Math.sqrt(rnd()) * (R - 8), cr = 2.4 + Math.pow(rnd(), 2) * 4.2;
      var cx = Math.cos(a) * rr, cy = Math.sin(a) * rr, ok = true;
      for (var c = 0; c < cols.length; c++) { var dx = cols[c][0] - cx, dy = cols[c][1] - cy; if (dx * dx + dy * dy < Math.pow(cols[c][2] + cr + 1.6, 2)) { ok = false; break; } }
      if (ok) cols.push([cx, cy, cr, 0.62 + rnd() * 0.34]);
    }
    function shuffled() { var o = cols.map(function (_, i) { return i; }); for (var i = o.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var tmp = o[i]; o[i] = o[j]; o[j] = tmp; } return o; }
    var plates = [{ key: 'ae', cx: 150, label: 'Oxygen', cls: 'tk-ox' }, { key: 'an', cx: 450, label: 'Limited oxygen', cls: 'tk-nox' }];
    plates.forEach(function (p) {
      var g = el('g', { 'class': 'tk-plate ' + p.cls, transform: 'translate(' + p.cx + ' 170)' });
      g.appendChild(el('text', { 'class': 'tk-name', x: 0, y: -142, 'text-anchor': 'middle' }, p.label));
      g.appendChild(el('circle', { 'class': 'tk-dish', r: R + 9 }));
      g.appendChild(el('circle', { 'class': 'tk-agar', r: R }));
      g.appendChild(el('circle', { 'class': 'tk-shine', r: R - 4 }));
      var cg = el('g', { 'class': 'tk-cols' });
      p.nodes = cols.map(function (k, i) {
        var n = el('circle', { 'class': 'tk-col', cx: k[0].toFixed(1), cy: k[1].toFixed(1), r: k[2].toFixed(2), 'fill-opacity': k[3].toFixed(2) });
        n.style.setProperty('--cd', Math.round(100 + Math.sqrt(k[0] * k[0] + k[1] * k[1]) / R * 320 + (i * 37) % 61 + (p.key === 'an' ? 70 : 0)) + 'ms');
        cg.appendChild(n); return n;
      });
      g.appendChild(cg);
      p.rank = []; shuffled().forEach(function (idx, r) { p.rank[idx] = r; });
      p.shown = N;
      svg.appendChild(g);
      p.pct = el('text', { 'class': 'tk-pct', x: p.cx, y: 334, 'text-anchor': 'middle' }, '100%');
      svg.appendChild(p.pct);
      svg.appendChild(el('text', { 'class': 'tk-sub', x: p.cx, y: 357, 'text-anchor': 'middle' }, 'still alive'));
    });
    function lerp(ts, vs, x) {
      if (x <= ts[0]) return vs[0];
      for (var i = 1; i < ts.length; i++) if (x <= ts[i]) { var k = (x - ts[i - 1]) / (ts[i] - ts[i - 1]); return vs[i - 1] + (vs[i] - vs[i - 1]) * k; }
      return vs[vs.length - 1];
    }
    function fmt(f) { var p = f * 100; if (p >= 99.5) return t > 10.5 ? '~100%' : '100%';   /* the strains' average held at about 100% (Tara) */ if (p >= 10) return Math.round(p) + '%'; if (p >= 1) return p.toFixed(1) + '%'; if (p >= 0.01) return p.toFixed(2) + '%'; return '<0.01%'; }
    function render() {
      plates.forEach(function (p) {
        var lv = p.key === 'ae' ? lerp(T_AE, AE, t) : lerp(T_AN, AN, t);
        var n = Math.round(N * Math.min(1, Math.pow(10, lv)));
        if (n !== p.shown) { p.nodes.forEach(function (node, idx) { node.classList.toggle('gone', p.rank[idx] >= n); }); p.shown = n; }
        p.pct.textContent = fmt(Math.pow(10, lv));
      });
      clock.textContent = Math.round(t) + ' min';
      scrub.value = Math.round(t);
      scrub.style.setProperty('--p', ((t - 10) / 230 * 100).toFixed(2) + '%');
      play.classList.toggle('is-end', t >= 239.5 && !playing);
    }
    function setPlaying(on) {
      playing = on;
      play.classList.toggle('is-playing', on);
      play.setAttribute('aria-label', on ? 'Pause time-lapse' : (t >= 239.5 ? 'Replay time-lapse' : 'Play time-lapse'));
    }
    function run() {
      cancelAnimationFrame(raf);
      if (t >= 239.5) { t = 10; render(); }
      setPlaying(true);
      var t0 = null, from = t;
      function step(now) {
        if (!playing) return;
        if (!t0) t0 = now;
        t = Math.min(240, from + (now - t0) / DUR * 230);
        render();
        if (t < 240) raf = requestAnimationFrame(step); else { setPlaying(false); render(); }
      }
      raf = requestAnimationFrame(step);
    }
    var pend = 0, wrap = svg.parentNode;
    function stop() { clearTimeout(pend); wrap.classList.remove('pre', 'seeding'); cancelAnimationFrame(raf); setPlaying(false); render(); }
    play.addEventListener('click', function () { if (playing) stop(); else run(); });
    scrub.addEventListener('input', function () { cancelAnimationFrame(raf); setPlaying(false); t = +scrub.value; render(); });
    render();
    /* the chart calls show() when the tab opens (plays once from the start) and stop() when another tab is chosen */
    window.__tk = {
      show: function (animate) {
        stop();
        if (!animate || reduced) { t = 240; render(); return; }
        t = 10; render();
        wrap.classList.add('pre'); void wrap.offsetWidth;                  /* start state, then let the set-up transitions run */
        wrap.classList.remove('pre'); wrap.classList.add('seeding');
        pend = setTimeout(function () { wrap.classList.remove('seeding'); run(); }, 1100);   /* colonies settled (~950ms): deplete */
      },
      stop: stop
    };
  })();

  document.querySelectorAll('.oxy-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (chip.classList.contains('on')) return;
      document.querySelectorAll('.oxy-chip').forEach(function (c) {
        c.classList.toggle('on', c === chip);
        c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
      });
      drawOxy(chip.getAttribute('data-set'), true);
    });
  });

  /* ---------- CONTACT: pick who you are, then one field that matters ---------- */
  (function () {
    var form = document.querySelector('.contact-form');
    if (!form) return;
    var hint = document.getElementById('choiceHint');
    var chips = form.querySelectorAll('.choice');
    var email = document.getElementById('cEmail');
    var err = document.getElementById('cEmailErr');
    var msg = document.getElementById('cMsg');
    var PLACEHOLDER = {
      parent: 'What would you like to know?',
      lactation: 'Where do you practise, and how might we help each other?',
      affiliate: 'Where do you reach parents, and what are you hoping to do together?',
      donate: 'Anything you would like us to know before we send the next steps.',
      work: 'Tell us what you do and why Booby Biome.',
      other: 'Whatever you would like to tell us.'
    };
    function select(topic) {
      chips.forEach(function (c) {
        var on = c.getAttribute('data-topic') === topic;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on) {
          hint.classList.add('swap');
          setTimeout(function () { hint.textContent = c.getAttribute('data-hint'); hint.classList.remove('swap'); }, reduced ? 0 : 160);
          if (msg) msg.placeholder = PLACEHOLDER[topic] || PLACEHOLDER.other;
          var topicIn = form.querySelector('input[name="contact[topic]"]'); if (topicIn) topicIn.value = c.textContent.trim();
        }
      });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { select(c.getAttribute('data-topic')); }); });
    (function () {
      var t = null; try { t = sessionStorage.getItem('bb-contact-topic'); sessionStorage.removeItem('bb-contact-topic'); } catch (e) {} if (t) select(t);
    })();
    /* Validation: inline, on submit and on correction; only the email is mandatory */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ok = email.value && email.checkValidity();
      email.setAttribute('aria-invalid', ok ? 'false' : 'true');
      err.classList.toggle('show', !ok);
      if (!ok) { email.focus(); return; }
      var zone = form.querySelector('[data-capture]');
      var echo = document.getElementById('cEcho'); if (echo) echo.textContent = email.value;
      zone.setAttribute('data-done', '');
      bbPost(form);
    }, true);
    email.addEventListener('input', function () { if (email.checkValidity()) { email.setAttribute('aria-invalid', 'false'); err.classList.remove('show'); } });
  })();

  /* ---------- FAQ: one open at a time ---------- */
  (function () {
    var items = document.querySelectorAll('.faq-item');
    if (!items.length) return;
    function setOpen(item, open) {
      var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) a.setAttribute('data-open', ''); else a.removeAttribute('data-open');
    }
    items.forEach(function (item) {
      item.querySelector('.faq-q').addEventListener('click', function () {
        var isOpen = item.querySelector('.faq-a').hasAttribute('data-open');
        items.forEach(function (o) { setOpen(o, false); });
        if (!isOpen) setOpen(item, true);
      });
    });
    if (!window.matchMedia('(max-width: 720px)').matches) setOpen(items[0], true);   /* phones start with every answer closed (Sam, 15 Sep) */
  })();

  /* ---------- WAITLIST CAPTURE ---------- */
  document.querySelectorAll('[data-capture]').forEach(function (zone) {
    if (zone.getAttribute('data-capture-kind') === 'contact') return;
    var form = zone.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      if (!input || !input.value || !input.checkValidity()) { if (input) input.focus(); return; }
      zone.setAttribute('data-done', '');
      bbKlaviyo(form);
      var done = zone.querySelector('.capture-done');
      if (done && !done.innerHTML) {
        done.innerHTML = '<h3>You&rsquo;re on the list.</h3>' +
          '<p class="data micro">We&rsquo;ll be in touch the moment BYOMI launches.</p>';
      }
    });
  });
  /* ---------- CONSENT: nothing optional before a choice; reject is one tap; settings reopen from the footer ---------- */
  (function () {
    var cc = document.getElementById('cookieBanner');
    if (!cc) return;
    var KEY = 'bb-consent-v1';
    var state = null;
    try { state = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { state = null; }

    function apply(c) {
      /* Tag loaders hook here: read data-consent-* on <html> (or window.__bbConsent) before setting anything. */
      document.documentElement.setAttribute('data-consent-analytics', c && c.analytics ? 'granted' : 'denied');
      document.documentElement.setAttribute('data-consent-marketing', c && c.marketing ? 'granted' : 'denied');
      window.__bbConsent = c;
      window.dispatchEvent(new CustomEvent('bb:consent', { detail: c }));
      if (c && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
            if (err || !window.Shopify.customerPrivacy) return;
            window.Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: true, sale_of_data: !!c.marketing }, function () {});
          });
        } catch (e) {}
      }
    }
    function save(c) {
      state = { analytics: !!c.analytics, marketing: !!c.marketing, at: new Date().toISOString() };
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
      apply(state);
    }
    function syncToggles() {
      cc.querySelectorAll('[data-cc-toggle]').forEach(function (sw) {
        var k = sw.getAttribute('data-cc-toggle');
        sw.setAttribute('aria-checked', state && state[k] ? 'true' : 'false');
      });
    }
    function open(view) {
      cc.setAttribute('data-view', view || 'notice');
      syncToggles();
      cc.hidden = false;
      void cc.offsetWidth;
      cc.classList.remove('is-closing');
      cc.classList.add('is-open');
    }
    function close() {
      cc.classList.remove('is-open');
      cc.classList.add('is-closing');
      var done = function () { cc.classList.remove('is-closing'); cc.hidden = true; };
      if (reduced) done(); else setTimeout(done, 210);
    }

    cc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cc]'); var sw = e.target.closest('[data-cc-toggle]');
      if (sw) { sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); return; }
      if (!btn) return;
      var a = btn.getAttribute('data-cc');
      if (a === 'accept') { save({ analytics: true, marketing: true }); close(); }
      else if (a === 'reject') { save({ analytics: false, marketing: false }); close(); }
      else if (a === 'save') {
        var c = {};
        cc.querySelectorAll('[data-cc-toggle]').forEach(function (s) { c[s.getAttribute('data-cc-toggle')] = s.getAttribute('aria-checked') === 'true'; });
        save(c); close();
      }
      else if (a === 'settings') { e.preventDefault(); cc.setAttribute('data-view', 'settings'); }
      else if (a === 'back') { cc.setAttribute('data-view', 'notice'); }
      else if (a === 'policy') { /* follow the link; the notice stays until a choice is made */ }
    });
    /* Footer + policy page: reopen straight into settings. */
    document.querySelectorAll('[data-cc-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open('settings'); });
    });

    apply(state);
    if (!state) { setTimeout(function () { open('notice'); }, 900); }
    window.__ccOpen = open; window.__ccReset = function () { try { localStorage.removeItem(KEY); } catch (e) {} state = null; apply(null); open('notice'); };
  })();

  /* ---------- WAITLIST DIALOG: every CTA opens it; the footer form stays as the fallback ---------- */
  (function () {
    var wl = document.getElementById('waitlistDialog');
    if (!wl) return;
    var supported = typeof wl.showModal === 'function';
    var closing = false;

    function openWaitlist() {
      if (!supported) { location.hash = '#waitlist'; return; }
      if (wl.open) return;
      closing = false;
      wl.classList.remove('is-closing');
      wl.showModal();
      /* Force a style flush so the dialog exists at its start state, then transition.
         (A layout read, not requestAnimationFrame - rAF is throttled in background tabs.) */
      void wl.offsetWidth;
      wl.classList.add('is-open');
      var input = wl.querySelector('input[type="email"]');
      var zone = wl.querySelector('[data-capture]');
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      /* Desktop: straight into the field. Touch: focus the heading so the keyboard
         does not shove the sheet before the reader has seen why it is there. */
      if (input && !coarse && !(zone && zone.hasAttribute('data-done'))) input.focus();
      else { var t = document.getElementById('wlTitle'); if (t) t.focus(); }
    }
    function closeWaitlist(after) {
      if (!wl.open || closing) return;
      closing = true;
      wl.classList.remove('is-open');
      wl.classList.add('is-closing');
      var finish = function () {
        wl.classList.remove('is-closing');
        if (wl.open) wl.close();
        closing = false;
        if (typeof after === 'function') after();
      };
      if (reduced) finish(); else setTimeout(finish, 210);
    }

    document.querySelectorAll('a.nav-cta[href="#waitlist"], a.pill[href="#waitlist"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); bbOpenKlaviyoForm(openWaitlist); });
    });
    wl.querySelectorAll('[data-wl-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href');
        e.preventDefault();
        closeWaitlist(href ? function () { if (href.charAt(0) === '#') location.hash = href; else location.href = href; } : null);
      });
    });
    wl.addEventListener('cancel', function (e) { e.preventDefault(); closeWaitlist(); });   /* Escape */
    wl.addEventListener('click', function (e) { if (e.target === wl) closeWaitlist(); });    /* scrim */
    window.__openWaitlist = openWaitlist;   /* test hook */
    window.__closeWaitlist = closeWaitlist;
  })();

  /* ---------- POSTED STATE: Shopify reloads the page after a challenge; show the same done state ---------- */
  document.querySelectorAll('[data-posted]').forEach(function (mark) {
    var zone = mark.closest('[data-capture]'); if (!zone) return;
    zone.setAttribute('data-done', '');
    var done = zone.querySelector('.capture-done');
    if (done && !done.innerHTML) {
      done.innerHTML = '<h3>You&rsquo;re on the list.</h3>' +
        '<p class="data micro">We&rsquo;ll be in touch the moment BYOMI launches.</p>';
    }
  });
})();
